<div class="container">
  <div class="site-body">
    <router-outlet/>
  </div>
</div>
